/**
 * Delare global variable.
 */

const formatter = new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'VND',
  minimumFractionDigits: 0
});

const taxPercent = 0.1;

const localeMessages = {
  en: {
    errorMessage: "Data is invalid. Please enter all required fields and enter the data in the correct format!",
    dateFormat: "Please enter the format dd/mm/yyyy and greater than 01/01/1900 (e.g 25/02/2018)",
    dateMaxCurrent: "Date must be greater than 01/12/1899 and smaller than current date",
    invalidTaxCode: "Wrong tax code format",
    emailInvalid: "Wrong email format",
    formatInvalid: "Please enter data in the correct format",
    specialCharacter: "Please do not enter special characters"
  },
  vi: {
    errorMessage: "Dữ liệu không hợp lệ. Vui lòng nhập đầy đủ dữ liệu vào trường bắt buộc và nhập đúng định dạng dữ liệu !",
    dateFormat: "Vui lòng nhập đúng định dạng dd/mm/yyyy và lớn hơn 01/01/1900 (ví dụ: 25/02/2018)",
    dateMaxCurrent: "Ngày phải lớn hơn 01/12/1899 và nhỏ hơn ngày hiện tại",
    invalidTaxCode: "Mã số thuế không đúng định dạng",
    emailInvalid: "Email phải đúng định dạng",
    formatInvalid: "Vui lòng nhập đúng định dạng",
    specialCharacter: "Vui lòng không nhập ký tự đặc biệt"
  },
  getMessage: code => {
    return localeMessages[localStorage.getItem("__language")][code];
  }
}

const errorMessage = 'Dữ liệu không hợp lệ. Vui lòng nhập đầy đủ dữ liệu vào trường bắt buộc và nhập đúng định dạng dữ liệu !';

/**
 * The branch auto complete function callback.
 */
var branchAutocompleteFnc;

/**
 * The customer autocomplete function callback.
 */
var customerAutocompleteFnc;

/**
 * Check text flag.
 */
const checkText = "checked='true'";

/**
 * Addresses
 */
var cities = JSON.parse(localStorage.getItem('cities') || '[]');
var districts = JSON.parse(localStorage.getItem('districts') || '[]');
var wards = JSON.parse(localStorage.getItem('wards') || '[]');
var selectedCity;
var selectedDistrict;
var selectedWard;

/**
 * Temp panel data
 */
var tempPanelData;

/**
 * Set disable for radio and checkbox when view document
 */
function disableFormFields() {
  jQuery(function ($) {
    $('input:radio, input:checkbox').attr('disabled', true);
  });
}

/**
 * Set disable for input when view document type
 */
function disableFormInput() {
  jQuery(function ($) {
    $('.contract-data-field').attr('disabled', true);
  });
}

/**
 * Set enable for radio and checkbox
 */
function enableFormFields() {
  jQuery(function ($) {
    $('input:radio, input:checkbox').attr('disabled', false);
  });
}

/**
 * Set enable for input
 */
function enableFormInput() {
  jQuery(function ($) {
    $('.contract-data-field').attr('disabled', false);
  });
}

/**
 * register auto complete observe.
 * @param {*} type 
 * @param {*} listener 
 */
function registerAutoCompleteObserve(type, listener) {
  $(document).on(type, listener);
}

/**
 * register branch auto complete.
 * @param {*} listener  callback method.
 */
function registerBranchAutoComplete(listener) {
  branchAutocompleteFnc = listener;
}

/**
 * register customer auto complete.
 * @param {*} listener callback method.
 */
function registerCustomerAutoComplete(listener) {
  customerAutocompleteFnc = listener;
}

/**
 * Show hiden class template.
 */
function showHidenClassTemplate() {
  $('.contract-data-field').show();
  $('.contract-data-text').show();
}

/**
 * Get document data
 * @param {*} callback 
 * @param toast: use for error announcement
 */
function getDocumentFormJsonDataJ(callback, toastr, panelData) {
  tempPanelData = panelData;
  // Trim data
  $("input").each(function () {
    $(this).val($(this).val().trim());
  });

  $("textarea").each(function () {
    $(this).val($(this).val().trim());
  });

  // Valation functions *****************************************************************
  // Date validation
  $.validator.addMethod(
    "customDate",
    function (value, element) {
      if (!value) {
        return true;
      }

      var tempValue = value;

      if (tempValue.length !== 10) {
        return false;
      } else {
        const da = tempValue.split('/');
        if (da.length !== 3 || da[0].length !== 2 || da[1].length !== 2 || da[2].length !== 4) {
          return false;
        } else if (!moment(tempValue, 'DD/MM/YYYY', true).isValid()) {
          return false;
        }
      }
      return true;
    },
    //"Vui lòng nhập đúng định dạng dd/mm/yyyy và lớn hơn 01/01/1900 (ví dụ: 25/02/2018)"
    localeMessages.getMessage('dateFormat')
  );

  $.validator.addMethod(
    'multipleDate',
    function (value, element, params) {
      var day = $('input[name="' + params[0] + '"]').val();
      var month = $('input[name="' + params[1] + '"]').val();
      var year = $('input[name="' + params[2] + '"]').val();
      if (!day && !month && !year) {
        return true;
      } else {
        var date = day + '/' + month + '/' + year

        if (date.length !== 10) {
          return false;
        } else {
          const da = date.split('/');
          if (da.length !== 3 || da[0].length !== 2 || da[1].length !== 2 || da[2].length !== 4) {
            return false;
          } else if (!moment(date, 'DD/MM/YYYY', true).isValid()) {
            return false;
          }
        }
        return true;
      }
    },
    //"Vui lòng nhập đúng định dạng dd/mm/yyyy và lớn hơn 01/01/1900 (ví dụ: 25/02/2018)"
    localeMessages.getMessage('dateFormat')
  );

  $.validator.addMethod(
    'separatedDate',
    function (value, element, params) {
      var day = $('input[name="' + params[0] + '"]').val();
      var month = $('input[name="' + params[1] + '"]').val();
      var year = $('input[name="' + params[2] + '"]').val();
      if (!day && !month && !year) {
        return true;
      } else {
        var date = day + '/' + month + '/' + year

        if (date.length !== 10) {
          return false;
        } else {
          const da = date.split('/');
          if (da.length !== 3 || da[0].length !== 2 || da[1].length !== 2 || da[2].length !== 4) {
            return false;
          } else if (!moment(date, 'DD/MM/YYYY', true).isValid()) {
            return false;
          }
        }
        return true;
      }
    },
    //"Vui lòng nhập đúng định dạng dd/mm/yyyy và lớn hơn 01/01/1900 (ví dụ: 25/02/2018)"
    localeMessages.getMessage('dateFormat')
  );

  $.validator.addMethod(
    'separatedDateNoYear',
    function (value, element, params) {
      var day = $('input[name="' + params[0] + '"]').val();
      var month = $('input[name="' + params[1] + '"]').val();
      var year = params[2];
      if (!day && !month) {
        return true;
      } else {
        var date = day + '/' + month + '/' + year

        if (date.length !== 10) {
          return false;
        } else {
          const da = date.split('/');
          if (da.length !== 3 || da[0].length !== 2 || da[1].length !== 2 || da[2].length !== 4) {
            return false;
          } else if (!moment(date, 'DD/MM/YYYY', true).isValid()) {
            return false;
          }
        }
        return true;
      }
    },
    //"Vui lòng nhập đúng định dạng dd/mm/yyyy và lớn hơn 01/01/1900 (ví dụ: 25/02/2018)"
    localeMessages.getMessage('dateFormat')
  );

  // Birthday / IssuedDay range validation
  $.validator.addMethod(
    "dateRange",
    function (value, element) {
      if (!value) {
        return true;
      }

      var tempValue = value;

      if (tempValue.length !== 10) {
        return false;
      } else {
        const da = tempValue.split('/');
        if (da.length !== 3 || da[0].length !== 2 || da[1].length !== 2 || da[2].length !== 4) {
          return false;
        } else if (!moment(tempValue, 'DD/MM/YYYY', true).isValid()) {
          return false;
        }
      }

      if (!moment.utc(tempValue, 'DD/MM/YYYY', true).isBefore(moment.utc(new Date())) || !moment.utc(tempValue, 'DD/MM/YYYY', true).isAfter(moment.utc('01/12/1899', 'DD/MM/YYYY', true))) {
        return false;
      }

      return true;
    },
    //"Ngày phải lớn hơn 01/12/1899 và nhỏ hơn ngày hiện tại"
    localeMessages.getMessage('dateMaxCurrent')
  );

  // Tax code validation
  $.validator.addMethod(
    "taxCode",
    function (value, element) {
      return validateTaxCode(value);
    },
    //"Mã số thuế không đúng định dạng"
    localeMessages.getMessage('invalidTaxCode')
  );

  $.validator.addMethod(
    "separatedTaxCode",
    function (value, element, params) {
      return validateTaxCode(params[0]);
    },
    //"Mã số thuế không đúng định dạng"
    localeMessages.getMessage('invalidTaxCode')
  );

  function validateTaxCode(value) {
    if (!value) {
      return true;
    }

    if (value.match(/\d{10,13}/g) == value ||
      value.match(/\d{10,13}[-]\d{1,3}/g) == value) {

      let tempTaxCode = value.trim();
      // replace - by "".
      tempTaxCode = tempTaxCode.replace('-', '');

      const firstCode = tempTaxCode.substring(0, 10).trim();
      if (firstCode.length < 10) {
        return false;
      }

      let secondCode = '';
      if (tempTaxCode.length > 10) {
        secondCode = tempTaxCode.substring(10, tempTaxCode.length).trim();
      }

      // string to array of numbers.
      const firstCodeArr = firstCode.split('');

      const a =
        // 31*số đầu tiên bên trái
        Number(firstCodeArr[0]) * 31
        // 29*số thứ 2
        +
        Number(firstCodeArr[1]) * 29
        // 23*số thứ 3
        +
        Number(firstCodeArr[2]) * 23
        // 19*số thứ 4
        +
        Number(firstCodeArr[3]) * 19
        // 17*số thứ 5
        +
        Number(firstCodeArr[4]) * 17
        // 13*số thứ 6
        +
        Number(firstCodeArr[5]) * 13
        // 7* số thứ 7
        +
        Number(firstCodeArr[6]) * 7
        // 5*số thứ 8
        +
        Number(firstCodeArr[7]) * 5
        // 3*số thứ 9.
        +
        Number(firstCodeArr[8]) * 3;

      // Lấy số A chia cho 11 lấy phần dư là số B,
      const b = a % 11;
      if (10 - b !== Number(firstCodeArr[9])) {
        return false;
      }

      // not exist second code.
      if (secondCode.length !== 0 && secondCode.length !== 3) {
        return false;
      }
    } else {
      return false;
    }
    return true;
  }

  // Not allow user to enter full of space to input value
  $.validator.addMethod(
    "noAllSpace",
    function (value, element) {
      if (!value) {
        return true;
      }

      return !(value.trim().length === 0);
    },
    //errorMessage
    localeMessages.getMessage('errorMessage')
  );

  // Email validation
  $.validator.addMethod(
    "isEmail",
    function (value, element) {
      if (!value) {
        return true;
      }

      const isValid = /^[_a-zA-Z0-9]+(\.[_a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,4})$/.test(value);
      if (isValid) {
        return true;
      }

      return false;
    },
    //"Email phải đúng định dạng"
    localeMessages.getMessage('emailInvalid')
  );

  // Unicode and space validation
  $.validator.addMethod(
    "unicodeAndSpace",
    function (value, element) {
      if (!value) {
        return true;
      }

      let initalValue = value;
      initalValue = initalValue.replace(/[^0-9a-zA-Z]*/g, '');

      if (initalValue !== value) {
        return false;
      }
      return true;
    },
    //"Vui lòng nhập đúng định dạng"
    localeMessages.getMessage('formatInvalid')
  );

  // Special character validation
  $.validator.addMethod(
    "specialCharacter",
    function (value, element) {
      if (!value) {
        return true;
      }

      let initalValue = value;
      initalValue = initalValue.replace(/[~!@#$%^&*()_+*?<>,.;:=` ]*/g, '');

      if (initalValue === value) {
        return true
      }
      return false;
    },
    //"Vui lòng không nhập ký tự đặc biệt"
    localeMessages.getMessage('specialCharacter')
  );

  // Phone validation
  $.validator.addMethod(
    "phoneValidation",
    function (value, element) {
      if (!value) {
        return true;
      }

      let initalValue = value;
      initalValue = initalValue.replace(/[^0-9-/~!@#$%^&*()_+*?<>,.;:=`]*/g, '');

      if (initalValue !== value) {
        return false;
      }
      return true;
    },
    "Số phone hoặc fax không đúng định dạng"
  );

  // Checkbox required
  $.validator.addMethod(
    "checkboxRequired",
    function (value, elem, param) {
      const checkClass = [".payment-method"];
      checkClass.each(function () { });
      return $(".roles:checkbox:checked").length > 0;
    },
    "You must select at least one!"
  );

  // Positive number validation
  $.validator.addMethod(
    "positiveNumber",
    function (value) {
      if (!value) {
        return true;
      }

      return Number(value) >= 0;
    },
    "Enter a positive number"
  );

  // Positive number validation
  $.validator.addMethod(
    "money",
    function (value) {
      if (!value) {
        return true;
      }

      var moneyValue = value.replace(/\u20ab/g, '').replace(/\./g, '').trim();

      return Number(moneyValue) >= 0;
    },
    "Enter a positive number"
  );
  // Valation functions *****************************************************************

  // const requiredMessage = '* Bắt buộc';
  // const maxlengthMessage = 'Vượt độ dài quy định';
  // const taxCodeFormatMessage = 'Mã số thuế không đúng định dạng';

  // Validation handler ******************************************************************************************
  $('#contract-form').validate({
    ignore: [],
    rules: {},
    submitHandler: (form, evt) => {
      // If everything is ok then go here
      evt.preventDefault();
      const $dataFields = $('#contract-form .contract-data-field');
      const values = new Object();

      $dataFields.each(function () {
        var dataField = $(this);
        var dataFieldName = dataField.attr('name');
        var dataFieldId = dataField.attr('id');
        var dataFieldType = dataField.attr('type');

        if (dataFieldType === 'checkbox') {
          values[dataFieldName] = dataField.is(':checked') ? checkText : "";
        } else if (dataFieldType === 'radio') {
          if (dataField.is(':checked')) {
            values[dataFieldName] = dataField.val();
          }
        } else if (dataField.is('table')) {
          $(this).find('input').each(function (index) {
            var inputValue = removeHtmlTags($(this));
            if ($(this).is(':checkbox')) {
              if ($(this).is(':checked')) {
                inputValue = inputCheckboxValue;
              } else {
                inputValue = '';
              }
            }
            $(this).siblings('label').show().text(inputValue);
            $(this).remove();
          });
          $(this).find('textarea').each(function (index) {
            var inputValue = removeHtmlTags($(this));
            $(this).siblings('label').show().text(inputValue);
            $(this).remove();
          });
          values[dataFieldId] = $(this).html();
        } else if (dataField.is('input') || dataField.is('textarea')) {
          var tempVal = removeHtmlTags(dataField);
          if (!tempVal) {
            tempVal = dataField.hasClass('isSeparatedTaxCode') ? '&nbsp;&nbsp;' : (dataField.hasClass('input-square') ? '&nbsp;&nbsp;' :  emptyInputValue);
          }
          values[dataFieldName] = tempVal;
        }
      });

      callback(values, tempPanelData);
      return false;
    },
    highlight: function (element) {
      if ($(element).is('button')) {
        return;
      }

      $(element).css('background', '#ffdddd');

      if ($(element).is(':checkbox')) {
        if (!$(element).attr('data-name') && !$(element).attr('data-required')) {
          $('#' + $(element).attr('name') + 'lbl').addClass('checbox-error'); // Highlight label if 1 checkbox required
        } else if ($(element).attr('data-name')) {
          $('#' + $(element).attr('data-name') + 'lbl').addClass('checbox-error'); // Highlight label if a group of checkboxes is required. The data-name attribute will allow user to select only one checkbox in a group.
        } else if ($(element).attr('data-required')) {
          $('#' + $(element).attr('data-required') + 'lbl').addClass('checbox-error'); // Highlight label if a group of checkboxes is required. The data-required attribute will allow user to select multiple checkboxes in a group and required at least one checkbox is checked.
        }
      }
    },
    // Called when the element is valid:
    unhighlight: function (element) {
      if ($(element).is('button')) {
        return;
      }

      $(element).css('background', 'transparent');

      if ($(element).is(':checkbox')) {
        if (!$(element).attr('data-name') && !$(element).attr('data-required')) {
          $('#' + $(element).attr('name') + 'lbl').removeClass('checbox-error'); // Unhighlight label if 1 checkbox required ok
        } else if ($(element).attr('data-name')) {
          $('#' + $(element).attr('data-name') + 'lbl').removeClass('checbox-error'); // Unhighlight label if 1 checkbox in group has been checked
        } else if ($(element).attr('data-required')) {
          $('#' + $(element).attr('data-required') + 'lbl').removeClass('checbox-error'); // Highlight label if a group of checkboxes required
        }
      }
    },
    errorPlacement: function (error, element) { },
    // Use toastr when error happened
    invalidHandler: function (form, validator) {
      if (toastr) {
        toastr.error(localeMessages.getMessage('errorMessage'));
      }
    }
  });
  // Validation handler ******************************************************************************************

  // Validation rules ********************************************************************************************
  // Validation rule for required
  $(".isRequired").each(function () {
    $(this).rules("add", {
      //tạm để ko bắt buộc
      required: false,
      //required: true,
      messages: {
        required: ''
      }
    });
  });

  // Validation rule for number
  $(".isNumber").each(function () {
    $(this).rules("add", {
      number: true,
      messages: {
        number: ''
      }
    });
  });

  // Validation rule for number
  $(".quantity").each(function () {
    $(this).rules("add", {
      number: true,
      messages: {
        number: ''
      }
    });
  });

  // Validation rule for date
  $(".isDate").each(function () {
    if ($(this).val() != '') {
      var date = $(this).val().split('/');
      if (date.length == 3) {
        if (date[0].length == 1) {
          date[0] = '0' + date[0];
        }

        if (date[1].length == 1) {
          date[1] = '0' + date[1];
        }

        $(this).val(date[0] + '/' + date[1] + '/' + date[2]);
      }
    }

    $(this).rules("add", {
      customDate: true,
      messages: {
        customDate: ''
      }
    });
  });

  $(".isSeparatedDate").each(function () {
    var day = $(this).data("day");
    var month = $(this).data("month");
    var year = $(this).data("year");

    if ($('#' + day).val().length == 1) {
      $('#' + day).val('0' + $('#' + day).val());
    }

    if ($('#' + month).val().length == 1) {
      $('#' + month).val('0' + $('#' + month).val());
    }

    $(this).rules("add", {
      separatedDate: [day, month, year],
      messages: {
        separatedDate: ''
      }
    });
  });

  $(".isSeparatedDateNoYear").each(function () {
    var day = $(this).data("day");
    var month = $(this).data("month");
    var year = $(this).data("year");

    $(this).rules("add", {
      separatedDateNoYear: [day, month, year],
      messages: {
        separatedDateNoYear: ''
      }
    });
  });

  $(".isSeparatedDateShortYear").each(function () {
    var day = $(this).data("day");
    var month = $(this).data("month");
    var prefixYear = $(this).data("prefixyear");
    var year = prefixYear + $('input[name="' + $(this).data("year") + '"]').val();

    $(this).rules("add", {
      separatedDateNoYear: [day, month, year],
      messages: {
        separatedDateNoYear: ''
      }
    });
  });

  // Validation rule for phone number
  $(".isPhoneNumber").each(function () {
    $(this).rules("add", {
      phoneValidation: true,
      messages: {
        phoneValidation: ''
      }
    });
  });

  // Validation rule for taxCode
  $(".isTaxCode").each(function () {
    $(this).rules("add", {
      taxCode: true,
      messages: {
        taxCode: ''
      }
    });
  });

  // Validation rule for Separated taxCode
  $(".isSeparatedTaxCode").each(function () {
    var itemList = $(this).data("itemlist").split(',');
    var taxCode = ''

    for (i = 0; i < itemList.length; i++) {
      taxCode += $('input[name="' + itemList[i] + '"]').val();
    }

    $(this).rules("add", {
      separatedTaxCode: [taxCode],
      messages: {
        taxCode: ''
      }
    });
  });

  // Validation rule for money
  $(".isMoney").each(function () {
    $(this).rules("add", {
      money: true,
      messages: {
        taxCode: ''
      }
    });
  });
  // Validation rules ********************************************************************************************

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // kenh truyen
  $('#contract-form [data-required="receivingMethod"]').each(function () {
    $(this).rules('add', {
      required: false,
      // required: {
      //   depends: function (element) {
      //     return $('#contract-form [data-required="receivingMethod"]:checked').length == 0;
      //   }
      // }
    });
  });

  // // kenh truyen
  $('#contract-form [data-required="detailingMethod"]').each(function () {
    $(this).rules('add', {
      //tạm để ko bắt buộc
      required: false,
      // required: {
      //   depends: function (element) {
      //     return $('#contract-form [data-required="detailingMethod"]:checked').length == 0;
      //   }
      // }
    });
  });

  // kenh truyen
  $('#contract-form [data-required="paymentMethod"]').each(function () {
    $(this).rules('add', {
      //tạm để ko bắt buộc
      required: false,
      // required: {
      //   depends: function (element) {
      //     return $('#contract-form [data-required="paymentMethod"]:checked').length == 0;
      //   }
      // }
    });
  });

  // kenh truyen
  $('#contract-form .serviceTypeKT').each(function () {
    $(this).rules('add', {
      //tạm để ko bắt buộc
      required: false,
      // required: true,
      messages: {
        required: 'this is a must requried field'
      }
    });
  });

  $('#contract-form .packageKT').each(function () {
    $(this).rules('add', {
      //tạm để ko bắt buộc
      required: false,
      // required: true,
      messages: {
        required: 'this is a must requried field'
      }
    });
  });

  $('#contract-form__submit').click();
}
////////////////////////////////////////////////////////////////////////////////////////////////

function getClassesOfElement(element) {
  return element.attr("class").split(" ");
}

/**
 * Hide form and do things
 */
function hideForm() {
  jQuery(function ($) {
    $('#contract-form').hide();
    $('#contract-form .display-data-field').hide();
    $('#contract-form .table-div-pdf').hide();

    $('#contract-form .contract-data-field').show();
    $('#contract-form .contract-data-text').show();
    $('#contract-form table.contract-data-field').find('input').each(function (index) {
      $(this).show();
      $(this).siblings('label').hide();
    });

    // format for table input.
    generateTableInput();

    //  Register event for document
    registerDocumentEvent();

    registerCalculation();
  });
}

/**
 * Show form
 */
function showForm() {
  jQuery(function ($) {
    $('#contract-form').show();
  });
}

const inputInfoClazz = "inputInfo";
const inputCheckboxClazz = "inputCheckbox";
const inputCheckboxValue = "√";

const inputAutoFillQuantityClass = "auto-fill-quantity";

const priceClazz = "price";
const quantityClazz = "quantity";
const totalClazz = "total";

const totalBeforeTaxClazz = "totalBeforeTax";
const taxClazz = "tax";
const totalWithTaxClazz = "totalWithTax";

const totalInTextClazz = "totalInText";
const emptyInputValue = "......";

/**
 * Generate table input.
 */
function generateTableInput() {
  $('.lblInputDoc').each(function (index) {
    var lbItem = $(this);

    const fontWeightClass = 'template-mapping-input-bold-weight';
    const areaFillInfoText = 'areaFillInfoText';

    if (lbItem.parent().find('input').length == 0) {
      var classess = getClassesOfElement(lbItem);
      var textfieldTypeTemplate = '<input type="text" class="{class}" value="{value}" style="{style}" name="{name}" {others} />';
      var textAreaTypeTemplate = '<textarea class="{class}" style="{style}" name="{name}" {others} rows="5">{value}</textarea>';
      var checkboxTemplate = '<input type="checkbox" class="{class}" name="{name}" {others} />'

      var replacedClazz = '';
      var replacedValue = '';
      var replacedStyle = '';
      var replacedName = '';
      var replacedOthers = '';

      if (classess.includes(inputCheckboxClazz)) {
        checkboxTemplate = checkboxTemplate.replace('{class}', 'm-0');

        if (lbItem.attr('data-name')) {
          replacedOthers += ' data-name="' + lbItem.attr('data-name') + '" ';
        }
        if (lbItem.attr('name')) {
          replacedName = lbItem.attr('name').trim();
          checkboxTemplate = checkboxTemplate.replace('{name}', replacedName);
        }
        if ($(lbItem).text() === inputCheckboxValue) {
          checkboxTemplate = checkboxTemplate.replace('{others}', 'checked="checked"' + replacedOthers);
        } else {
          checkboxTemplate = checkboxTemplate.replace('{others}', replacedOthers);
        }
        lbItem.parent().prepend(checkboxTemplate);
        $(lbItem).hide();
        return;
      } else if (classess.includes(inputInfoClazz)) {
        // input info.
        // generate input of input info.
        // & set value for input.
        replacedClazz = 'inputDocTb';
        replacedValue = lbItem.text().replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
        replacedStyle = 'width: 100%; text-align: left;';
      } else if (classess.includes(priceClazz)) {
        // price
        // generate input of price.
        // & set value for input.
        replacedClazz = 'inputDocTb';
        replacedValue = lbItem.text().replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
        replacedStyle = 'width: 100%; text-align: right;';
        // replacedName = 'price';
      } else if (classess.includes(quantityClazz)) {
        // quantity.
        // generate input of quantity.
        // & set value for input.
        replacedClazz = 'inputDocTb';
        if (classess.includes(inputAutoFillQuantityClass)) {
          replacedClazz += 'input-auto-fill-quantity ';
        }
        replacedValue = lbItem.text().replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
        replacedStyle = 'width: 100%; text-align: center;';
        // replacedName = 'quantity';
      } else if (classess.includes(totalClazz)) {
        // total.
        // generate input of total
        // & set value for input.
        replacedClazz = 'inputDocTb';
        replacedValue = lbItem.text().replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
        replacedStyle = 'width: 100%; text-align: right;';
        // replacedName = 'total';
        replacedOthers = 'readonly="true" tabindex="-1"';
      } else if (classess.includes(totalBeforeTaxClazz)) {
        // totalBeforeTax.
        // generate input of total
        // & set value for input.
        replacedClazz = 'inputDocTb';
        replacedValue = lbItem.text().replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
        replacedStyle = 'width: 100% ;text-align: right;';
        // replacedName = 'totalBeforeTax';
        replacedOthers = 'readonly="true" tabindex="-1"';
      } else if (classess.includes(taxClazz)) {
        // tax.
        // generate input of total
        // & set value for input.
        replacedClazz = 'inputDocTb';
        replacedValue = lbItem.text().replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
        replacedStyle = 'width: 100%; text-align: right;';
        // replacedName = 'tax';
        replacedOthers = 'readonly="true" tabindex="-1"';
      } else if (classess.includes(totalWithTaxClazz)) {
        // totalWithTax.
        // generate input of total
        // & set value for input.
        replacedClazz = 'inputDocTb';
        replacedValue = lbItem.text().replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
        replacedStyle = 'width: 100%; text-align: right;';
        // replacedName = 'totalWithTax';
        replacedOthers = 'readonly="true" tabindex="-1"';
      } else if (classess.includes(totalInTextClazz)) {
        // totalWithTax.
        // generate input of total
        // & set value for input.
        // lbItem.attr('name', 'totalInText');
      }

      if (lbItem.attr('data-class')) {
        replacedClazz += ' ' + lbItem.attr('data-class') + ' ';
      }
      if (lbItem.attr('name')) {
        replacedName = lbItem.attr('name').trim();
      }

      if (!classess.includes(totalInTextClazz)) {
        if (classess.includes(fontWeightClass)) {
          replacedClazz = replacedClazz + " " + fontWeightClass;
        }

        if (classess.includes(areaFillInfoText)) {
          if (lbItem.parent().find('textarea').length == 0) {
            replacedStyle = 'width: 100%; height: 96%; text-align: left; margin-top: 3px;';

            var textAreaControl = textAreaTypeTemplate
              .replace("{class}", replacedClazz)
              .replace("{value}", replacedValue)
              .replace("{style}", replacedStyle)
              .replace("{name}", replacedName)
              .replace("{others}", replacedOthers);

            lbItem.parent().append(textAreaControl);
          }
        } else {
          var textfieldControl = textfieldTypeTemplate
            .replace('{class}', replacedClazz)
            .replace('{value}', replacedValue)
            .replace('{style}', replacedStyle)
            .replace('{name}', replacedName)
            .replace('{others}', replacedOthers);

          lbItem.parent().append(textfieldControl);
        }
      }

      if (!classess.includes(totalInTextClazz)) {
        $(lbItem).hide();
      }
    }
  });
}

/**
 * The autocomplete data of supplier.
 */
var autocompleteNewSupplier = [];

/**
 * getten branches full properties.
 */
var gottenBranchs = [];

/**
 * gotten customers
 */
var gottenCustomers = [];

/**
 * Register event for document
 */
function registerDocumentEvent() {
  const selectorForAutocompletedCustomer = "input[name='newCustomerName']";
  const selectorForAutocompletedBranchesAndEnterprises = "input[name='newSupplierName']";
  const selectorForAutocompletedWard = "input.autocompletedWard";
  const selectorForAutocompletedDistrict = "input.autocompletedDistrict";
  const selectorForAutocompletedCity = "input.autocompletedCity";

  // Remove click event on add and delete button to avoid duplicate event
  $(document).off('click', '.dataTable__addRow');
  $(document).off('click', '.dataTable__deleteRow');
  $(':checkbox').off('click');
  $('.auto-fill').off('click');

  $(selectorForAutocompletedBranchesAndEnterprises).autocomplete({
    source: function (request, response) {
      branchAutocompleteFnc(request.term, function (data) {
        if (!data) {
          return;
        }

        gottenBranchs = [];
        let branches = [];

        data.forEach(branchItem => {
          if (branchItem.name.startsWith(request.term)) {
            branches.push({
              id: branchItem.id,
              value: branchItem.name,
              label: branchItem.name
            });

            gottenBranchs.push(branchItem);
          }
        });

        response(branches);
      });
    },
    minLength: 1,
    select: function (event, ui) {

      if (!gottenBranchs) {
        return;
      }

      gottenBranchs.forEach(branchItem => {
        if (branchItem.id === ui.item.id) {
          // bind data of branch to below items.
          var newBranchObject = {
            newSupplierAccountNumber: branchItem.accountNumber ? branchItem.accountNumber : '',
            newSupplierAddress: branchItem.addresses ? branchItem.addresses[0].address : '',
            newSupplierWardName: branchItem.addresses && wards ? getWardName(wards, branchItem.addresses[0].wardId).name : '',
            newSupplierDistrictName: branchItem.addresses && districts ? getDistrictName(districts, branchItem.addresses[0].districtId).name : '',
            newSupplierCityName: branchItem.addresses && cities ? getCityName(cities, branchItem.addresses[0].cityId).name : '',
            newSupplierAdminUser: branchItem.adminUser ? branchItem.adminUser : '',

            newSupplierBankBranch: branchItem.bankBranch ? branchItem.bankBranch : '',
            newSupplierBankName: branchItem.bankName ? branchItem.bankName : '',
            newSupplierCertificateNo: branchItem.certificateNo ? branchItem.certificateNo : '',
            newSupplierEmail: branchItem.email ? branchItem.email : '',
            newSupplierFax: branchItem.fax ? branchItem.fax : '',
            newSupplierIssuedAt: branchItem.issuedAt ? branchItem.issuedAt : '',
            newSupplierIssuedDate: branchItem.issuedDate ? formatDate(new Date(branchItem.issuedDate)) : '',
            newSupplierName: branchItem.name ? branchItem.name : '',
            newSupplierParentName: branchItem.parentName ? branchItem.parentName : '',
            newSupplierPhone: branchItem.phone ? branchItem.phone : '',
            newSupplierPosition: branchItem.position ? branchItem.position : '',
            newSupplierRepresentative: branchItem.representative ? branchItem.representative : '',
            newSupplierRepresentativeCertificateNo: branchItem.representativeCertificateNo ? branchItem.representativeCertificateNo : '',
            newSupplierRepresentativeIssuedOn: branchItem.representativeIssuedOn ? branchItem.representativeIssuedOn : '',
            newSupplierTaxCode: branchItem.taxCode ? branchItem.taxCode : '',
          }
          bindData(newBranchObject);
          return;
        }
      });
    },
    open: function () {
      $(this).removeClass("ui-corner-all").addClass("ui-corner-top");
      $(this).autocomplete("widget").css({
        "width": ($(this).width() + "px")
      });
    },
    close: function () {
      $(this).removeClass("ui-corner-top").addClass("ui-corner-all");
    }
  });

  $(selectorForAutocompletedCustomer).autocomplete({
    source: function (request, response) {
      customerAutocompleteFnc(request.term, function (data) {
        if (!data) {
          return;
        }

        gottenCustomers = [];
        const customers = [];

        data.forEach(customerItem => {
          customers.push({
            id: customerItem.id,
            value: customerItem.name,
            label: customerItem.name
          });

          gottenCustomers.push(customerItem);
        });

        response(customers);
      });
    },
    minLength: 10,
    select: function (event, ui) {
      if (!gottenCustomers) {
        return;
      }

      gottenCustomers.forEach(customerItem => {
        if (customerItem.id === ui.item.id) {
          var newCustomerObject = {};
          newCustomerObject.newCustomerAccountNumber = customerItem.accountNumber ? customerItem.accountNumber : '';
          // newCustomerObject.newCustomerAddress = customerItem.address ? customerItem.address : '';
          newCustomerObject.newCustomerAdminUser = customerItem.adminUser ? customerItem.adminUser : '';
          newCustomerObject.newCustomerAttachments = customerItem.attachments ? customerItem.attachments : '';
          newCustomerObject.newCustomerBankBranch = customerItem.bankBranch ? customerItem.bankBranch : '';
          newCustomerObject.newCustomerBankName = customerItem.bankName ? customerItem.bankName : '';
          newCustomerObject.newCustomerBank = `${customerItem.bankName ? customerItem.bankName + ', ' : ''}${customerItem.bankBranch ? customerItem.bankBranch : ''}`;
          newCustomerObject.newCustomerBirthday = customerItem.birthday ? formatDate(new Date(customerItem.birthday)) : null;
          newCustomerObject.newCustomerCertificateId = customerItem.certificateId ? customerItem.certificateId : '';
          newCustomerObject.newCustomerCertificateNo = customerItem.certificateNo && customerItem.customerType ? customerItem.certificateNo : '';
          // newCustomerObject.newCustomerCityId = customerItem.cityId ? customerItem.cityId : '';
          newCustomerObject.newCustomerType = customerItem.customerType ? customerItem.customerType : '';
          // newCustomerObject.newCustomerDistrictId = customerItem.districtId ? customerItem.districtId : '';
          newCustomerObject.newCustomerEmail = customerItem.email ? customerItem.email : '';
          newCustomerObject.newCustomerReceiverEmail = customerItem.email ? customerItem.email : '';
          newCustomerObject.newCustomerEnterpriseId = customerItem.enterpriseId ? customerItem.enterpriseId : '';
          newCustomerObject.newCustomerFax = customerItem.fax ? customerItem.fax : '';
          newCustomerObject.newCustomerId = customerItem.id ? customerItem.id : '';
          newCustomerObject.newCustomerIssuedAt = customerItem.issuedAt ? customerItem.issuedAt : '';
          newCustomerObject.newCustomerIssuedDate = customerItem.issuedDate ? formatDate(new Date(customerItem.issuedDate)) : null;
          newCustomerObject.newCustomerIssuedDay = customerItem.issuedDate ?
            new Date(customerItem.issuedDate).getDate() :
            null;
          newCustomerObject.newCustomerIssuedMonth = customerItem.issuedDate ?
            new Date(customerItem.issuedDate).getMonth() + 1 :
            null;
          newCustomerObject.newCustomerIssuedYear = customerItem.issuedDate ?
            new Date(customerItem.issuedDate).getFullYear().toString().slice(-2) :
            null;
          newCustomerObject.newCustomerName = customerItem.name ? customerItem.name : '';
          newCustomerObject.newCustomerPhone = customerItem.phone ? customerItem.phone : '';
          newCustomerObject.newCustomerReceiverPhone = customerItem.phone ? customerItem.phone : '';
          newCustomerObject.newCustomerPosition = customerItem.position ? customerItem.position : '';
          newCustomerObject.newCustomerPrimaryEmail = customerItem.primaryEmail ? customerItem.primaryEmail : '';
          newCustomerObject.newCustomerRepresentative = customerItem.representative ?
            customerItem.representative :
            '';
          newCustomerObject.newCustomerRepresentativeCertificateId = customerItem.representativeCertificateId ?
            customerItem.representativeCertificateId :
            '';
          newCustomerObject.newCustomerRepresentativeCertificateNo = customerItem.representativeCertificateNo ?
            customerItem.representativeCertificateNo :
            '';
          newCustomerObject.newCustomerRepresentativeIssuedAt = customerItem.representativeIssuedAt ?
            customerItem.representativeIssuedAt :
            '';
          newCustomerObject.newCustomerRepresentativeIssuedDate = customerItem.representativeIssuedDate ?
            formatDate(new Date(customerItem.representativeIssuedDate)) :
            null;
          newCustomerObject.newCustomerSex = customerItem.sex && customerItem.sex == true ?
            'Nam' :
            customerItem.sex == false ? 'Nữ' : '';
          newCustomerObject.newCustomerTaxCode = customerItem.taxCode ? customerItem.taxCode : '';
          // newCustomerObject.newCustomerWardId = customerItem.wardId ? customerItem.wardId : '';
          newCustomerObject.newCustomerAddressUsing = customerItem.address ? customerItem.address : '';
          newCustomerObject.newCustomerContacter = customerName;
          newCustomerObject.newCustomerIndividualOrRepresentativeCertificate = customerItem.customerType === 10000 ?
            customerItem.certificateNo :
            customerItem.representativeCertificateNo;
          newCustomerObject.newCustomerIndividualOrRepresentativeIssuedAt = customerItem.customerType === 10000 ?
            customerItem.issuedAt :
            customerItem.representativeIssuedAt;
          newCustomerObject.newCustomerIndividualOrRepresentativeIssuedDate = customerItem.customerType === 10000 ?
            formatDate(new Date(customerItem.issuedDate)) :
            formatDate(new Date(customerItem.representativeIssuedDate));
          newCustomerObject.newCustomerIndividualOrRepresentativeIssuedDay = newCustomerObject.newCustomerIndividualOrRepresentativeIssuedDate ?
            new Date(newCustomerObject.newCustomerIndividualOrRepresentativeIssuedDate).getDate() :
            null;
          newCustomerObject.newCustomerIndividualOrRepresentativeIssuedMonth = newCustomerObject.newCustomerIndividualOrRepresentativeIssuedDate ?
            new Date(newCustomerObject.newCustomerIndividualOrRepresentativeIssuedDate).getMonth() + 1 :
            null;
          newCustomerObject.newCustomerIndividualOrRepresentativeIssuedYear = newCustomerObject.newCustomerIndividualOrRepresentativeIssuedDate ?
            new Date(newCustomerObject.newCustomerIndividualOrRepresentativeIssuedDate).getFullYear() :
            null;
          newCustomerObject.newCustomerIndividualOrRepresentativeIssuedShortYear = newCustomerObject.newCustomerIndividualOrRepresentativeIssuedDate ?
            new Date(newCustomerObject.newCustomerIndividualOrRepresentativeIssuedDate).getFullYear().toString().slice(-2) :
            null;

          newCustomerObject.newCustomerBusinessCertificateNo = customerItem.customerType !== 10000 ?
            customerItem.certificateNo :
            '';
          newCustomerObject.newCustomerBusinessCertificateIssuedAt = customerItem.customerType !== 10000 ?
            customerItem.issuedAt :
            '';
          newCustomerObject.newCustomerBusinessCertificateIssuedDate = customerItem.customerType !== 10000 ?
            formatDate(new Date(customerItem.issuedDate)) :
            '';
          newCustomerObject.newCustomerBusinessCertificateIssuedDay = newCustomerObject.newCustomerBusinessCertificateIssuedDate ?
            new Date(newCustomerObject.newCustomerBusinessCertificateIssuedDate).getDate() :
            null;
          newCustomerObject.newCustomerBusinessCertificateIssuedMonth = newCustomerObject.newCustomerBusinessCertificateIssuedDate ?
            new Date(newCustomerObject.newCustomerBusinessCertificateIssuedDate).getMonth() + 1 :
            null;
          newCustomerObject.newCustomerBusinessCertificateIssuedYear = newCustomerObject.newCustomerBusinessCertificateIssuedDate ?
            new Date(newCustomerObject.newCustomerBusinessCertificateIssuedDate).getFullYear() :
            null;
        }

        bindData(newCustomerObject);
        return;
      });
    },
    open: function () {
      $(this).removeClass("ui-corner-all").addClass("ui-corner-top");
      $(this).autocomplete("widget").css({
        "width": ($(this).width() + "px")
      });
    },
    close: function () {
      $(this).removeClass("ui-corner-top").addClass("ui-corner-all");
    }
  });

  var autocompletedCityArray = $(selectorForAutocompletedCity);
  var autocompletedDistrictArray = $(selectorForAutocompletedDistrict);
  var autocompletedWardArray = $(selectorForAutocompletedWard);
  var gottenCities;
  var gottenDistricts;
  var gottenWards;

  autocompletedCityArray.each(function () {
    $(this).autocomplete({
      source: function (request, response) {
        gottenCities = [];
        let citiesArray = [];

        cities.forEach(city => {
          if (city.name.startsWith(request.term)) {
            citiesArray.push({
              id: city.id,
              value: city.name,
              label: city.name
            });

            gottenCities.push(city);
          }
        });
        response(citiesArray);
      },
      minLength: 1,
      select: function (event, ui) {
        if (!gottenCities) {
          return;
        }

        gottenCities.forEach(branchItem => {
          if (branchItem.id === ui.item.id) {
            // by data of branch to below items.
            return;
          }
        });
      },
      open: function () {
        $(this).removeClass("ui-corner-all").addClass("ui-corner-top");
        $(this).autocomplete("widget").css({
          "width": ($(this).width() + "px")
        });
      },
      close: function () {
        $(this).removeClass("ui-corner-top").addClass("ui-corner-all");
      }
    });
  });

  autocompletedDistrictArray.each(function () {
    $(this).autocomplete({
      source: function (request, response) {
        gottenDistricts = [];
        let districtsArray = [];

        districts.forEach(district => {
          if (district.name.startsWith(request.term)) {
            districtsArray.push({
              id: district.id,
              value: district.name,
              label: district.name
            });

            gottenDistricts.push(district);
          }
        });
        response(districtsArray);
      },
      minLength: 1,
      select: function (event, ui) {
        if (!gottenDistricts) {
          return;
        }

        gottenDistricts.forEach(district => {
          if (district.id === ui.item.id) {
            // by data of branch to below items.
            return;
          }
        });
      },
      open: function () {
        $(this).removeClass("ui-corner-all").addClass("ui-corner-top");
        $(this).autocomplete("widget").css({
          "width": ($(this).width() + "px")
        });
      },
      close: function () {
        $(this).removeClass("ui-corner-top").addClass("ui-corner-all");
      }
    });
  });

  autocompletedWardArray.each(function () {
    $(this).autocomplete({
      source: function (request, response) {
        gottenWards = [];
        let wardsArray = [];

        wards.forEach(ward => {
          if (ward.name.startsWith(request.term)) {
            wardsArray.push({
              id: ward.id,
              value: ward.name,
              label: ward.name
            });

            gottenWards.push(ward);
          }
        });
        response(wardsArray);
      },
      minLength: 1,
      select: function (event, ui) {
        if (!gottenWards) {
          return;
        }

        gottenWards.forEach(ward => {
          if (ward.id === ui.item.id) {
            // by data of branch to below items.
            return;
          }
        });
      },
      open: function () {
        $(this).removeClass("ui-corner-all").addClass("ui-corner-top");
        $(this).autocomplete("widget").css({
          "width": ($(this).width() + "px")
        });
      },
      close: function () {
        $(this).removeClass("ui-corner-top").addClass("ui-corner-all");
      }
    });
  });

  // When check the auto-fill, get the value of this checkbox and fill in the value of destinationFields
  $('.auto-fill').on('click', function () {
    const autoFill = $(this).attr('data-autoname');
    const isChecked = $(this).prop("checked");
    const autoFillVal = $(this).val();
    var destinationFields = $("[data-autodestination='" + autoFill + "']");
    destinationFields.each(function () {
      if (isChecked) {
        $(this).val(autoFillVal);
      } else {
        $(this).val('');
      }
    })
  });

  // If group of checboxes have same data-name attribute then system only allows user to choose one
  $('#contract-form').on('click', ':checkbox', function () {
    var box = $(this);
    var boxStage = box.prop("checked");
    var closestRow = $(this).closest('tr');
    var attrValue = $(this).attr("data-name");

    if (attrValue) {
      var group

      if (attrValue == 'receivingMethod' || attrValue == 'paymentMethod' || attrValue == 'detailingMethod' || attrValue == 'type') {
        group = $('#contract-form').find("input:checkbox[data-name='" + attrValue + "']");
      } else {
        group = closestRow.find("input:checkbox[data-name='" + attrValue + "']");
      }

      $(group).prop("checked", false).change();
      box.prop("checked", boxStage);
    }

    var list = $('.payment-method-input');
    if (list.length > 0) {
      if ($(this).attr('data-target') === 'payment-method-input') {
        var next = true;
        if ($(this).prop("checked") === false) {
          $('input:checkbox[data-target="payment-method-input"]').each(function () {
            if ($(this).prop("checked") === true) {
              next = false;
            }
          });
        }
        for (var i = 0; i < list.length; i++) {
          if (next === true) {
            list[i].disabled = $(this).prop("checked") === false ? true : false;
          } else {
            list[i].disabled = false;
          }
        }
      }
    }

    var listKT = $('.promotion-attend-input');
    if (listKT.length > 0) {
      if ($(this).attr('data-target') === 'promotion-attend-input') {
        next = true;
        if ($(this).prop("checked") === false) {
          $('input:checkbox[data-target="promotion-attend-input"]').each(function () {
            if ($(this).prop("checked") === true) {
              next = false;
            }
          });
        }
        for (var j = 0; j < listKT.length; j++) {
          if (next === true) {
            listKT[j].disabled = $(this).prop("checked") === false ? true : false;
          } else {
            listKT[j].disabled = false;
          }
        }
      }
    }

    if ($(this).attr('data-target') && $(this).attr('data-target') !== 'payment-method-input' && $(this).attr('data-target') !== 'promotion-attend-input') {
      list = document.getElementsByClassName($(this).attr('data-target'));
      for (var k = 0; k < list.length; k++) {
        list[k].disabled = !$(this).prop("checked");
      }
    }
  });

  // Register event dynamically for dataTable__addRow button
  $(document).on('click', '.dataTable__addRow', function () {
    var tds = '<tr>';
    var parent = $(this).closest('table');
    var rowspanElement = parent.find('.row-span');
    if (rowspanElement.length > 0) {
      rowspanElement.attr('rowspan', Number(rowspanElement.attr('rowspan')) + 1);
    }
    var parentID = parent.attr('id');
    jQuery.each($('tbody tr:last td', parent), function () {
      var style = $(this).attr('style') ? $(this).attr('style') : '';
      var classes = $(this).attr('class') ? $(this).attr('class') : '';
      var html = $(this).html();
      tds += '<td class="' + classes + '" style="' + style + '">' + html + '</td>';
    });
    tds += '</tr>';
    if ($('tbody', parent).length > 0) {
      $('tbody', parent).append(tds);
    } else {
      $(parent).append(tds);
    }
    // Remove td if rowspan exits
    jQuery.each($('tbody tr:last td:last', parent), function () {
      if ($(this).closest('tr').prev().find('td:last').attr('rowspan')) {
        $(this).remove();
      }
    });
    jQuery.each($('tbody tr:last td', parent), function () {
      var input = $(this).find('input');
      if (input.length > 0) {
        if ($(input).attr('type') == 'checkbox') {
          $(input).prop('checked', false);
        } else {
          $(input).attr('value', '');
        }
      }
    });
    calculateData(parent);
    registerCalculation();

    var rowCount = $('#' + parentID + ' tr').length;
    jQuery.each($('tbody tr:last td', parent), function () {
      var input = $(this).find('input[type=text]');
      if (input.length > 0 && $(input).attr('name') != '') {
        $(input).attr('name', $(input).attr('name') + '_' + rowCount);
      }

      var label = $(this).find('label');
      if (label.length > 0 && $(label).attr('name') != '') {
        $(label).attr('name', $(label).attr('name') + '_' + rowCount);
      }
    });
  });

  // Register event dynamically for dataTable__deleteRow button
  $(document).on('click', '.dataTable__deleteRow', function () {
    var parent = $(this).closest('table');
    if ($(parent).find('tbody tr').length > 1) {
      $(parent).find('tbody tr:last').remove();
      var rowspanElement = parent.find('.row-span');
      if (rowspanElement.length > 0) {
        rowspanElement.attr('rowspan', Number(rowspanElement.attr('rowspan')) - 1);
      }
    }
    calculateData(parent);
  });

  registerCalculation();
}

// Bind data when update
function bindData(formData) {
  jQuery(function ($) {
    for (var key in formData) {
      var value = formData[key];
      if (value === emptyInputValue || value == '&nbsp;&nbsp;') {
        value = '';
      }
      if (!key.startsWith('table')) {
        bindDatabyType('name', value, key);
      } else {
        var table = $('#' + key);
        table.html(value);
      }
    }

    generateTableInput();

    registerCalculation();
  });
  $("input").each(function () {
    $(this).change();
  });
}

function bindDatabyType(type, value, key, overWrite) {
  element = $('#contract-form ' + '[' + type + '="' + key + '"]');
  if (element.is('input')) { // if field is an input or textarea
    if (element.attr('type') === 'text') { // input type = text
      if (type == 'data-autofill') {
        if (overWrite) {
          element.val(value);
        } else if (element.val() == '') {
          element.val(value);
        }
      } else {
        element.val(value);
      }
    } else if (element.attr('type') === 'checkbox') { // input type = checkbox
      element.prop('checked', value === checkText ? true : false);
    } else if (element.attr('type') === 'radio') {
      var $radios = $('input:radio[name=' + key + ']');
      if ($radios.is(':checked') === false) {
        $radios.filter('[value=' + value + ']').prop('checked', true);
      }
    }
  } else if (element.is('table')) {
    $(this).find('input').each(function () {
      $(this).attr('value', $(this).val());
    });
  } else if (element.is('textarea')) {
    if (type == 'data-autofill') {
      if (overWrite) {
        element.val(value);
      } else if (element.val() == '') {
        element.val(value);
      }
    } else {
      element.val(value);
    }
  }
}

/**
 * Bind autofill data to template
 * @param {*} data 
 */
function bindAutofillDataJ(data, overWrite) {
  jQuery(function ($) {
    for (var key in data) {
      var value = data[key];
      if (value === emptyInputValue) {
        value = '';
      }
      if (!key.startsWith('table')) {
        bindDatabyType('data-autofill', value, key, overWrite);
      }
    }
  });
  $("input").each(function () {
    $(this).change();
  });
}

/**
 * Remove all html tags when getting input value
 */
function removeHtmlTags(field) {
  if (!field.length) {
    return '';
  }

  var div = $('<div/>');
  div.html(field.val());
  div.contents().filter(function () {
    return this.nodeType !== 3;
  }).after(function () {
    return $(this).text();
  }).remove();
  return div.html();
}

// Register calcution
function registerCalculation() {
  var quantityFields = $('input.quantity');
  var priceFields = $('input.price');
  var totalFields = $('input.total');

  quantityFields.off('keyup blur');

  priceFields.off('keyup blur');

  quantityFields.on('keyup blur', function () {
    calculateData($(this).closest('table'));
  });

  priceFields.on('blur', function (e) {
    var value = $(this).val().replace(/\u20ab/g, '').replace(/\./g, '').trim();
    if (!isNaN(value)) {
      if (value == 0) {
        value = ''
      } else {
        value = formatter.format(value);
      }
      $(this).val(value.replace(/\xa0\u20ab/g, ' \u20ab'));
      calculateData($(this).closest('table'));
    }
  });
}

/**
 * Calculate price
 * @param {*} parentTable 
 */
function calculateData(parentTable) {
  var quantityFields = $(parentTable).find('input.quantity');
  var priceFields = $(parentTable).find('input.price');
  var totalFields = $(parentTable).find('input.total');

  var totalBeforeTaxField = $(parentTable).find('input.totalBeforeTax');
  var taxField = $(parentTable).find('input.tax');
  var totalWithTaxField = $(parentTable).find('input.totalWithTax');
  var totalInTextField = $(parentTable).find('label.totalInText');

  var totalBeforeTaxValue = 0;
  var totalWithTaxValue = 0;


  totalFields.each(function (index) {
    var unitPriceItem = 0;
    var unitPriceItemString = '';

    if (priceFields.length > index) {
      unitPriceItemString = $(priceFields[index]).val().replace(/\u20ab/g, '').replace(/\./g, '');
      if (unitPriceItemString !== "") {
        unitPriceItem = parseInt(unitPriceItemString);
      }
    }

    var quantityItem = 0;
    if (quantityFields.length == 0 || quantityFields.length <= index) {
      quantityItem = 1;
    } else if ($(quantityFields[index]).val() && !isNaN($(quantityFields[index]).val())) {
      quantityItem = parseInt($(quantityFields[index]).val());
    }

    var moneyItem = quantityItem * unitPriceItem;
    if (unitPriceItemString != '' && !isNaN(unitPriceItem)) {
      $(this).val(formatter.format(moneyItem).replace(/\xa0\u20ab/g, ' \u20ab'));
    } else {
      $(this).val('');
    }

    // tinh tong tien.
    totalBeforeTaxValue += moneyItem;
  });

  // Tinh thue
  var taxValue = totalBeforeTaxValue * taxPercent;

  // Tinh tong tien co thue.
  totalWithTaxValue = totalBeforeTaxValue + taxValue;

  // set value into control
  if (totalBeforeTaxValue > 0) {
    $(totalBeforeTaxField).val(formatter.format(totalBeforeTaxValue).replace(/\xa0\u20ab/g, ' \u20ab'));
    $(taxField).val(formatter.format(taxValue).replace(/\xa0\u20ab/g, ' \u20ab'));
    $(totalWithTaxField).val(formatter.format(totalWithTaxValue).replace(/\xa0\u20ab/g, ' \u20ab'));

    // convert number to text.
    totalInTextField.text(money2Text(Math.round(totalWithTaxValue)) + './.');
  } else {
    $(totalBeforeTaxField).val('');
    $(taxField).val('');
    $(totalWithTaxField).val('');
    totalInTextField.text('');
  }
}

/**
 * Define character number of Vietnamese.
 */
var ChuSo = new Array(" không", " một", " hai", " ba", " bốn", " năm", " sáu", " bảy", " tám", " chín");

/**
 * Define unit of money.
 */
var Tien = new Array("", " nghìn", " triệu", " tỷ", " nghìn tỷ", " triệu tỷ");

/**
 * Hàm đọc số có ba chữ số
 */
function readThreeCharacterNumber(baso) {
  var tram;
  var chuc;
  var donvi;
  var result = "";

  tram = parseInt(baso / 100);
  chuc = parseInt((baso % 100) / 10);

  donvi = baso % 10;

  if (tram == 0 && chuc == 0 && donvi == 0) return "";
  if (tram != 0) {
    result += ChuSo[tram] + " trăm";
    if ((chuc == 0) && (donvi != 0)) result += " linh";
  }

  if ((chuc != 0) && (chuc != 1)) {
    result += ChuSo[chuc] + " mươi";
    if ((chuc == 0) && (donvi != 0)) result = result + " linh";
  }

  if (chuc == 1) {
    result += " mười";
  }

  switch (donvi) {
    case 1:
      if ((chuc != 0) && (chuc != 1)) {
        result += " mốt ";
      } else {
        result += ChuSo[donvi];
      }
      break;
    case 5:
      if (chuc == 0) {
        result += ChuSo[donvi];
      } else {
        result += " lăm";
      }
      break;
    default:
      if (donvi != 0) {
        result += ChuSo[donvi];
      }
      break;
  }
  return result;
}

var mangso = ['không', 'một', 'hai', 'ba', 'bốn', 'năm', 'sáu', 'bảy', 'tám', 'chín'];

function dochangchuc(so, daydu) {
  var chuoi = "";
  let chuc = Math.floor(so / 10);
  let donvi = so % 10;
  if (chuc > 1) {
    chuoi = " " + mangso[chuc] + " mươi";
    if (donvi == 1) {
      chuoi += " mốt";
    }
  } else if (chuc == 1) {
    chuoi = " mười";
    if (donvi == 1) {
      chuoi += " một";
    }
  } else if (daydu && donvi > 0) {
    chuoi = " lẻ";
  }

  if (donvi == 5 && chuc >= 1) {
    chuoi += " lăm";
  } else if (donvi > 1 || (donvi == 1 && chuc == 0)) {
    chuoi += " " + mangso[donvi];
  }
  return chuoi;
}

function docblock(so, daydu) {
  var chuoi = "";
  let tram = Math.floor(so / 100);
  so = so % 100;
  if (daydu || tram > 0) {
    chuoi = " " + mangso[tram] + " trăm";
    chuoi += dochangchuc(so, true);
  } else {
    chuoi = dochangchuc(so, false);
  }
  return chuoi;
}

function dochangtrieu(so, daydu) {
  var chuoi = "";
  let trieu = Math.floor(so / 1000000);
  so = so % 1000000;
  if (trieu > 0) {
    chuoi = docblock(trieu, daydu) + " triệu";
    daydu = true;
  }
  let nghin = Math.floor(so / 1000);
  so = so % 1000;
  if (nghin > 0) {
    chuoi += docblock(nghin, daydu) + " nghìn";
    daydu = true;
  }
  if (so > 0) {
    chuoi += docblock(so, daydu);
  }
  return chuoi;
}

function docso(so) {
  if (so == 0) return mangso[0];
  var chuoi = "",
    hauto = "";
  do {
    let ty = so % 1000000000;
    so = Math.floor(so / 1000000000);
    if (so > 0) {
      chuoi = dochangtrieu(ty, true) + hauto + chuoi;
    } else {
      chuoi = dochangtrieu(ty, false) + hauto + chuoi;
    }
    hauto = " tỷ";
  } while (so > 0);
  return chuoi;
}

/**
 * Hàm đọc số thành chữ (Sử dụng hàm đọc số có ba chữ số)
 * @param {*} amount so tien bang so.
 */
function money2Text(amount) {
  let result = docso(amount);
  return result.substring(1, 2).toUpperCase() + result.substring(2) + ' đồng';
}

/**
 * Format Date to dd/mm/yyyy
 */

function formatDate(date) {
  if (!date) {
    return '';
  }
  const dd = date.getDate();
  var newDD = dd.toString();
  const mm = date.getMonth() + 1;
  var newMM = mm.toString();
  const yyyy = date.getFullYear();

  if (dd < 10) {
    newDD = '0' + dd;
  }
  if (mm < 10) {
    newMM = '0' + mm;
  }
  return newDD + '/' + newMM + '/' + yyyy;
}


/**
 * Get city name from cities array
 */
function getCityName(cities, cityId) {
  const selectedCity = cities.find(x => {
    return x.id == cityId;
  });
  if (selectedCity == undefined || selectedCity == null) {
    return {
      id: null,
      name: '',
      description: ''
    };
  }
  return selectedCity;
}

/**
 * Get district name from districts array
 */
function getDistrictName(districts, districtId) {
  const selectedDistrict = districts.find(x => {
    return x.id == districtId;
  });
  if (selectedDistrict == undefined || selectedDistrict == null) {
    return {
      id: null,
      cityId: null,
      name: '',
      description: ''
    };
  }
  return selectedDistrict;
}

/**
 * Get ward name from wards array
 */
function getWardName(wards, wardId) {
  const selectedWard = wards.find(x => {
    return x.id == wardId;
  });
  if (selectedWard == undefined || selectedWard == null) {
    return {
      id: null,
      districtId: null,
      name: '',
      description: ''
    };
  }
  return selectedWard;
}

function toggleItem(itemID, value) {
  if (value) {
    $('#' + itemID).removeAttr('disabled')
  } else {
    $('#' + itemID).attr('disabled', true)
  }
}


function clearSelectionJ() {
  if (window.getSelection) {
    window.getSelection().removeAllRanges();
  } else if (document.selection) {
    document.selection.empty();
  }
}

// Dinh dang tien theo don vi tien te hien tai
function formatMoney(number, currency) {
  var value = parseFloat(number);
  //check neu la so Int
  //if (value % 1 === 0) {
  //    if (currency == "USD")
  //        value = value.toFixed(2);
  //    else
  //        value = value.toFixed(0);
  //}
  //else {
  //    value = value.toFixed(2);
  //}

  // Lay 2 chu so sau dau phai doi voi dong USD
  value = value.toFixed(currency == "USD" ? 2 : 0);

  // Bo sung dau phay
  var valueWithComma = numberWithCommas(value);
  // console.log("valueWithComma: ", valueWithComma);

  // Bo sung ky tu don vi tien te
  switch (currency.toUpperCase()) {
    case "VND":
      return valueWithComma + " ₫";
    case "USD":
      return "$ " + valueWithComma;
    case "IDR":
      return "Rp " + valueWithComma;
    default:
      return valueWithComma;
  }
}

function numberWithCommas(number) {
  if (number == null || number == undefined){
    return "";
  }
  return number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") || '';
}
